import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useRouter,
  useNuxtApp,
} from 'nuxt/app'
import { localePath } from '~/utility/route'

export default defineNuxtRouteMiddleware(async (to) => {
  if (process.server) {
    return
  }
  const authStore = useAuthStore()
  if (!authStore.isLoggedIn) {
    await authStore.authCheck
  }
  if (!authStore.isLoggedIn) {
    const router = useRouter()
    const nuxtApp = useNuxtApp()
    const targetLocale = nuxtApp.$i18n.locale
    const url = localePath(
      {
        name: 'accounts-login',
        query: {
          next: to.fullPath,
        },
      },
      targetLocale,
      router,
      'en-gb',
    )
    return navigateTo(url, { redirectCode: 302 })
  }
})
